<template>
    <b-modal auto-focus no-close-on-backdrop :visible="true" hide-footer :title="`${Object.keys(formData).length === 0 ? 'Crear' : 'Editar'} ${title}`"
        @close="$emit('close')" size="lg" no-close-on-esc>
        <b-row>
            <b-col v-for="field in fields" :key="field.id" :md="field.properties.columnSize || 12" :sm="12"
                class="mb-4">
                <DynamicField :component="field" :model-value="formValues[field.id]"
                    @input="updateFieldValue(field.id, $event)" :error="formErrors[field.id]" />
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col class="d-flex justify-content-end">
                <b-button variant="danger" @click="$emit('close')">Cancelar</b-button>
                <b-button type="submit" class="ml-2" variant="primary" @click="submitForm">
                    {{ Object.keys(formData).length === 0 ? 'Guardar' : 'Actualizar' }}
                </b-button>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
import DynamicField from "./DynamicField.vue"

export default {
    name: "DynamicFormModal",
    components: {
        DynamicField
    },
    props: {
        fields: {
            type: Array,
            required: true
        },
        formData: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            default: "Formulario"
        }
    },
    data() {
        return {
            formValues: {},
            formErrors: {},
        }
    },
    created() {
        this.initializeFormValues()
    },
    methods: {
        initializeFormValues() {
            const values = {}
            this.fields.forEach((field) => {
                values[field.id] = this.formData[field.id] !== undefined ? this.formData[field.id] : null;
            });
            this.formValues = values
        },

        updateFieldValue(fieldId, value) {
            this.$set(this.formValues, fieldId, value)
        },

        validateFields() {
            this.formErrors = {};
            let isValid = true;

            this.fields.forEach((field) => {
                const value = this.formValues[field.id];
                const { required, maxlength } = field.properties;

                if (maxlength && value && value.length > maxlength) {
                    this.$set(this.formErrors, field.id, `Este campo no puede tener más de ${maxlength} caracteres`);
                    isValid = false;
                }

                if (required) {
                    if (Array.isArray(value) && value.length === 0) {
                        this.$set(this.formErrors, field.id, "Este campo es obligatorio");
                        isValid = false;
                    } else if (!Array.isArray(value) && (value === null || value === "" || value === undefined)) {
                        this.$set(this.formErrors, field.id, "Este campo es obligatorio");
                        isValid = false;
                    }
                }

            });

            return isValid;
        },

        submitForm() {
            if (!this.validateFields()) {
                return;
            }

            this.$emit("submit", { ...this.formValues });
        },
    },
    watch: {
        formData: {
            handler() {
                this.initializeFormValues()
            },
            deep: true
        }
    }
}
</script>
